<template>
  <div class="editor-bottom-wrap" :class="themeClassName">
    <!-- (urlInfo.fileId) -->
    <el-tabs v-model="activeName" type="border-card" :before-leave="handleLeave"
             @tab-click="(e)=>handleClickLeftBottom(e)">
      <template>
        <!-- v-if="!(getUrlTypeInfo==='school')" -->
        <el-tab-pane label="QA" name="first">
          <QACheck />
        </el-tab-pane>
        <el-tab-pane v-if="haveModificationRecord" label="修改记录" name="second">
          <ModifyRecord />
        </el-tab-pane>
      </template>
      <el-tab-pane label="原文预览" name="third">
        <SourcePreview />
      </el-tab-pane>
      <el-tab-pane label="译文预览" name="fourth">
        <TargetPreview />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import QACheck from "./QAcheck";
import ModifyRecord from "./modifyRecord";
import SourcePreview from "./sourcePreview";
import TargetPreview from "./targetPreview";
import debounce from "lodash.debounce";
import Throttle from "lodash.throttle";
export default {
  name: "EditorBottom",
  components: { QACheck, ModifyRecord, SourcePreview, TargetPreview },
  data() {
    return {
      haveModificationRecord: haveModificationRecord,
      data: null,
      index: 1,
      activeName: 'first',
      urlInfo: JSON.parse(this.$Base64.decode(this.$route.query.key)) || {},
      debounceName: "",
    };
  },
  computed: {
    ...mapGetters('editor', [
      'getUrlInfo',                // 路由参数 
      'getThemeInfo',              // 主题信息
      'getFilePreviewContentInfo', // 获取原文预览数据
      'getFileInfo', //文件信息
    ]),
    //获取主题
    themeClassName() {
      if (this.getThemeInfo) {
        switch (this.getThemeInfo) {
          case 'dark':
            return 'dark-editor-bottom-wrap';
          case 'eye-protection':
            return 'eye-protection-editor-bottom-wrap'
        }
      }
      return ''
    },
    //获取url type信息
    getUrlTypeInfo() {
      if (this.getUrlInfo && this.getUrlInfo.type) {
        return this.getUrlInfo.type
      }
      return ''
    },
  },

  mounted() {
    // let urlInfo = (this.urlInfo);
    // if (!!urlInfo && !!(urlInfo.type) && ((urlInfo.type) === 'school')) {
    //   this.activeName = 'second';
    //   let params = {};
    //   Reflect.set(params, 'transProjectId', (urlInfo.projectId));
    //   Reflect.set(params, 'transFileId', urlInfo.fileId);
    //   Reflect.set(params, 'partIndex', 1);
    //   Reflect.set(params, 'sentId', "");
    //   Reflect.set(params, 'taskId', urlInfo.taskId);
    //   this.$store.dispatch('editor/setModifyRecordInfo', params)
    // } else {
    //   }
    const { fileId, taskId } = this.getUrlInfo
    const QA_Params = {
      fileId,
      taskId,
      // transModel: 1
    }
    this.setQACheckInfo(QA_Params);
    this.$nextTick(() => {
      this.debounceName = Throttle(this.handleClickLeftBottom, 1000)
      let scrollDom = document.getElementsByClassName('el-tabs__content');
      if (scrollDom) {
        scrollDom[0].addEventListener('scroll', debounce(this.handleScroll, 1000))
      }
    })
  },
  methods: {
    // 滚动事件- 触底加载分页数据
    handleScroll(e) {
      const self = this;
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      let scrollTop = e.target.scrollTop;
      //变量windowHeight是可视区的高度
      let windowHeight = e.target.clientHeight;
      //变量scrollHeight是滚动条的总高度
      let scrollHeight = e.target.scrollHeight;
      //滚动条到底部的条件
      console.log("滚动")
      if (Math.ceil(scrollTop + windowHeight + 10) >= scrollHeight) {
        let params = Object();
        let filePreviewContentInfo = Object();

        //写后台加载数据的函数
        // console.log("触底加载更多的数据:距顶部" + scrollTop + "可视区高度" + windowHeight + "滚动条总高度" + scrollHeight);
        console.log("this.activeName", this.activeName)
        switch (this.activeName) {
          case "second":
            let modifyRecordInfo = (self.$store.getters['editor/getModifyRecordInfo']);
            // console.log(modifyRecordInfo)
            if ((Reflect.has(modifyRecordInfo, 'state')) && (modifyRecordInfo.state)) {
              console.log("this.activeName")
              params = (self.$store.getters['editor/getModifyRecordParamsInfo']);
              let nextIndex = (parseInt(params.partIndex) + 1);
              self.setModifyRecordInfo(nextIndex);
            }
            break;
          case "third":
            filePreviewContentInfo = (self.$store.getters['editor/getFilePreviewContentInfo']);
            if ((Reflect.has(filePreviewContentInfo, 'state')) && (filePreviewContentInfo.state)) {
              params = (self.$store.getters['editor/getPreviewParamsInfo']) || {};
              let nextIndex = (parseInt(params.partIndex) + 1);
              // console.log(nextIndex)
              self.setPreviewInfo(nextIndex);
            }
            break;
          case "fourth":
            filePreviewContentInfo = (self.$store.getters['editor/getFilePreviewContentInfo']);
            if ((Reflect.has(filePreviewContentInfo, 'state')) && (filePreviewContentInfo.state)) {
              params = (self.$store.getters['editor/getPreviewParamsInfo']) || {};
              let nextIndex = (parseInt(params.partIndex) + 1);
              self.setPreviewInfo(nextIndex);
            }
            break;
        }
      }
    },

    //底部Tab切换
    handleClickLeftBottom(tab) {
      let contentDom = document.getElementsByClassName('el-tabs__content')[0];
      // let targetDom = document.getElementsByClassName("target-preview-inside")[0];
      let index = 1
      var timer = null;
      timer = setTimeout(() => {
        if (contentDom.scrollHeight > contentDom.clientHeight) {
          console.log("出现滚动条")
        } else {
          clearInterval(timer)
          if (tab.name === "third" || tab.name === "fourth") {
            index += 1
            this.setPreviewInfo(index)
            timer = null
          }
        }
      }, 1000);
      this.$store.dispatch('editor/setEditorBottomActiveName', (tab.name));
      const { fileId, taskId } = this.getUrlInfo
      const QA_Params = {
        fileId,
        taskId,
        // transModel: 1
      }
      switch (tab.name) {
        case 'first':
          //QA
          this.setQACheckInfo(QA_Params);
          break;
        case 'second':
          //修改记录
          // this.setModifyRecordInfo(1);
          break;
        case 'third':
          //原文预览
          this.setPreviewInfo();
          break;
        case 'fourth':
          //译文预览
          this.setPreviewInfo();
          break;
        default:
          this.setQACheckInfo(QA_Params);
          break;
      }
    },

    //QA 列表
    setQACheckInfo(params) {
      this.$store.dispatch('editor/QACheckFileTaskInfo', params)
    },

    //修改记录
    setModifyRecordInfo(index = 1) {
      const self = this;
      let fileId = 0;
      let urlInfo = self.$store.getters['editor/getUrlInfo'];
      if ((urlInfo.type) === 'project') {
        let fileInfo = self.$store.getters['editor/getFileInfo'];
        fileId = (fileInfo.id);
      } else if (((urlInfo.type) === 'task') || ((urlInfo.type) === 'school')) {
        let fileTaskInfo = self.$store.getters['editor/getFileTaskInfo'];
        fileId = (fileTaskInfo.fileId);
      }
      let params = (self.$store.getters['editor/getModifyRecordParamsInfo']) || {};
      console.log(fileId, urlInfo.projectId)
      Reflect.set(params, 'transProjectId', (urlInfo.projectId));
      Reflect.set(params, 'transFileId', fileId);
      Reflect.set(params, 'partIndex', index);
      Reflect.set(params, 'sentId', "");
      Reflect.set(params, 'taskId', urlInfo.taskId);
      self.$store.dispatch('editor/setModifyRecordInfo', params)
    },

    //原文预览-译文预览
    setPreviewInfo(index = 1) {
      const self = this;
      self.index = 1;
      let params = Object();
      let fileId = 0;
      let taskId = 0;
      if ((self.urlInfo.type) === 'project') {
        let fileInfo = self.$store.getters['editor/getFileInfo'];
        fileId = (fileInfo.id) || (self.urlInfo.fileId);
      } else if (((self.urlInfo.type) === 'task') || ((self.urlInfo.type) === 'school')) {
        let fileTaskInfo = self.$store.getters['editor/getFileTaskInfo'];
        fileId = (fileTaskInfo.fileId) || (self.urlInfo.fileId);
        taskId = (fileTaskInfo.id) || (self.urlInfo.taskId);
      }
      Reflect.set(params, 'partIndex', 1);
      Reflect.set(params, 'fileId', fileId);
      Reflect.set(params, 'taskId', taskId);
      Reflect.set(params, 'partIndex', index);
      this.$store.dispatch('editor/setPreviewInfo', params);
    },

    //底部Tab离开清空数据
    handleLeave(newName, oldName) {
      if (oldName === 'second') {
        let params = (this.$store.getters['editor/getModifyRecordParamsInfo']) || {};
        Reflect.set(params, 'partIndex', 1);
        //设置参数
        this.$store.dispatch('editor/setModifyRecordParamsInfo', params);
        //清除数据
        let paramsInfo = Object();
        Reflect.set(paramsInfo, 'result', Array());
        Reflect.set(paramsInfo, 'state', false);
        this.$store.dispatch('editor/setModifyRecordInfo2', paramsInfo);
      }
      if ((oldName === 'third') || (oldName === 'fourth')) {
        let previewParams = (this.$store.getters['editor/getPreviewParamsInfo']) || {};
        Reflect.set(previewParams, 'partIndex', 1);
        this.$store.dispatch('editor/setPreviewParamsInfo', previewParams);
        let paramsInfo = Object();
        Reflect.set(paramsInfo, 'convertStr', '');
        Reflect.set(paramsInfo, 'sourceStr', '');
        Reflect.set(paramsInfo, 'state', false);
        this.$store.dispatch('editor/setPreviewInfo2', paramsInfo);
      }
    },
  }
}
</script>
<style lang="less" scoped>
@import "./assets/style.less";
</style>